import * as React from 'react'

import { AllyUserRole } from '@ally/transmitigator'
import { Alert, Space, TextBody } from '@ally/metronome-ui'

import { getDisplayRole } from '../../Utils'

interface LoggedInAlertProps {
  displayRole?: string
  roles?: AllyUserRole
  username: string
}

const AlertHeading: React.FC<LoggedInAlertProps> = ({
  displayRole,
  roles = {
    guest: false,
    auto: false,
    bank: false,
    creditcard: false,
    mortgage: false,
    investment: false,
    wealth: false,
  },
  username,
}) => {
  const role = displayRole || getDisplayRole(roles)

  return (
    <>
      You&apos;re logged in to{' '}
      <TextBody size="sm" tag="b" weight="bold">
        {role}
      </TextBody>{' '}
      as {username}.
    </>
  )
}

const LoggedInAlert: React.FC<LoggedInAlertProps> = ({
  displayRole,
  roles,
  username,
}) => {
  if (!displayRole && !roles) {
    throw new Error('Either displayRole or roles are required')
  }

  return (
    <Space mb="sm">
      <Alert
        variant="success"
        disableContainer
        heading={
          <AlertHeading
            displayRole={displayRole}
            roles={roles}
            username={username}
          />
        }
      />
    </Space>
  )
}

export default LoggedInAlert
